import {
  GETPHYSIOTHERAPY,
  CREATEPHYSIOTHERAPY,
  UPDATEPHYSIOTHERAPYBYID,
  DELETEPHYSIOTHERAPY,
  GETPHYSIOTHERAPYSEVERITY,
  CREATEPHYSIOTHERAPYSEVERITY,
  DELETEPHYSIOTHERAPYSEVERITY,
  UPDATEPHYSIOTHERAPYSEVERITYBYID,
  /*************************** */
  GETPAINNATURE,
  CREATEPAINNATURE,
  UPDATEPHYSIOTHERAPYPAINNATUREBYID,
  DELETEPAINNATURE,
  GETPHYSIOTHERAPYPAINONSET,
  CREATEPAINONSET,
  UPDATEPHYSIOTHERAPPAINONSETBYID,
  DELETEPAINONSET,
  GETPHYSIOTHERAPYDIURNAL,
  CREATEPHYSIOTHERAPYDIURNAL,
  UPDATEPHYSIOTHERAPYDIURNALBYID,
  DELETEPHYSIOTHERAPYDIURNAL,
  GETPHYSIOTHERAPYTESTTYPE,
  CREATEPHYSIOTHERAPYTESTTYPE,
  UPDATEPHYSIOTHERAPYTESTTYPEBYID,
  DELETEPHYSIOTHERAPYTESTTYPE,
  GETPHYSIOTHERAPYTEST,
  CREATEPHYSIOTHERAPYTEST,
  UPDATEPHYSIOTHERAPYTESTBYID,
  DELETEPHYSIOTHERAPYTYPE,
  GETPHYSIOTHERAPYTESTINVESTIGATION,
  CREATEPHYSIOTHERAPYTESTINVESTIGATION,
  UPDATEPHYSIOTHERAPYTESTTINVESTIGATIONBYID,
  DELETEPHYSIOTHERAPYTYPETINVESTIGATION,
  GETPHYSIOTHERAPYTPROGNOSIS,
  CREATEPHYSIOTHERAPYPROGNOSIS,
  UPDATEPHYSIOTHERAPYPROGNOSISBYID,
  DELETEPHYSIOTHERAPYPROGNOSIS,
  GETPHYSIOTHERAPYTDIAGNOSIS,
  CREATEPHYSIOTHERAPYDIAGNOSIS,
  UPDATEPHYSIOTHERAPYDIAGNOSISBYID,
  DELETEPHYSIOTHERAPYDIAGNOSIS,
  GETPHYSIOTHERAPYFREQUENCY,
  CREATEPHYSIOTHERAPYFREQUENCY,
  UPDATEPHYSIOTHERAPYFREQUENCYBYID,
  DELETEPHYSIOTHERAPYFREQUENCY,
  GETPHYSIOTHERAPYDUTYCYCLE,
  CREATEPHYSIOTHERAPYDUTYCYCLE,
  UPDATEPHYSIOTHERAPYDUTYCYCLEBYID,
  DELETEPHYSIOTHERAPYDUTYCYCLE,
  GETPHYSIOTHERAPYWARMING,
  CREATEPHYSIOTHERAPYWARMING,
  UPDATEPHYSIOTHERAPYWARMINGBYID,
  DELETEPHYSIOTHERAPYWARMING,
  GETPHYSIOTHERAPYINTENSITY,
  CREATEPHYSIOTHERAPYINTENSITY,
  UPDATEPHYSIOTHERAPYINTENSITYBYID,
  DELETEPHYSIOTHERAPYINTENSITY,
} from '../actions/types';

const initialState = {
  physiotherapyList: [],
  physiotherapySaveStatus: null,
  editStatus: null,
  /*******/
  physiotherapySeverityList: [],
  physiotherapySaveSeverity: null,
  painNatureList: [],  // New state for pain nature
  painNatureSaveStatus: null, // Save status for pain natu
  /*******/
  physiotherapyOnSetList: [],
  physiotherapyPainOnSet: null,
  /************************ */
  physiotherapyDiurnalList: [],
  physiotherapyDiurnal: null,
  /************************ */
  physiotherapytesttypeList: [],
  createphysiotherapyTestType: null,
  /************************ */
  physiotherapyTestList: [],
  createphysiotherapyTest: null,
  /************************ */
  physiotherapyTestInvestigationList: [],
  createphysiotherapyInvestigationTest: null,
  /************************ */
  physiotherapyDiagnosisList: [],
  createphysiotherapyDiagnosis: null,
  /************************ */
  physiotherapyPrognosisList: [],
  createphysiotherapyPrognosis: null,
  /************************ */
  physiotherapyFrequencyList: [],
  createphysiotherapyFrequencyTest: null,
  /************************ */
  physiotherapyDutyCycleList: [],
  createphysiotherapyDutyCycleTest: null,
  /************************ */
  physiotherapyWarmingList: [],
  createphysiotherapyWarmingTest: null,
  /************************ */
  physiotherapyIntensityList: [],
  createphysiotherapyIntensityTest: null,

}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {

    case GETPHYSIOTHERAPYINTENSITY:
      return {
        ...state,
        physiotherapyIntensityList: Array.isArray(action.payload) ? action.payload : [], // Ensure the payload is an array
      };

    case CREATEPHYSIOTHERAPYINTENSITY:
      return {
        ...state,
        createphysiotherapyIntensityTest: action.payload.success,
      }

    case UPDATEPHYSIOTHERAPYINTENSITYBYID:
      const updatedListIntensity = state.createphysiotherapyIntensityTest.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        createphysiotherapyIntensityTest: updatedListIntensity, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPYINTENSITY:
      return {
        ...state,
        createphysiotherapyIntensityTest: Array.isArray(state.createphysiotherapyIntensityTest)
          ? state.createphysiotherapyIntensityTest.filter(item => item.id !== action.payload.data.id)
          : [], 
        physiotherapyDeleteIntensity: action.payload.success,
      };


    case GETPHYSIOTHERAPYWARMING:
      return {
        ...state,
        physiotherapyWarmingList: Array.isArray(action.payload) ? action.payload : [], // Ensure the payload is an array
      };

    case CREATEPHYSIOTHERAPYWARMING:
      return {
        ...state,
        createphysiotherapyWarmingTest: action.payload.success,
      }

    case UPDATEPHYSIOTHERAPYWARMINGBYID:
      const updatedListWarming = state.createphysiotherapyWarmingTest.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        createphysiotherapyWarmingTest: updatedListWarming, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPYWARMING:
      return {
        ...state,
        createphysiotherapyWarmingTest: Array.isArray(state.createphysiotherapyWarmingTest)
          ? state.createphysiotherapyWarmingTest.filter(item => item.id !== action.payload.data.id)
          : [],  // Ensure it's an array before calling filter
        physiotherapyDeleteWarming: action.payload.success, // Assuming you have this in your state
      };




    /*************************************************8 */
    case GETPHYSIOTHERAPYDUTYCYCLE:
      return {
        ...state,
        physiotherapyDutyCycleList: Array.isArray(action.payload) ? action.payload : [], // Ensure the payload is an array
      };

    case CREATEPHYSIOTHERAPYDUTYCYCLE:
      return {
        ...state,
        createphysiotherapyDutyCycleTest: action.payload.success,
      }

    case UPDATEPHYSIOTHERAPYDUTYCYCLEBYID:
      const updatedListDutyCycle = state.createphysiotherapyDutyCycleTest.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        createphysiotherapyDutyCycleTest: updatedListDutyCycle, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPYDUTYCYCLE:
      return {
        ...state,
        createphysiotherapyDutyCycleTest: Array.isArray(state.createphysiotherapyDutyCycleTest)
          ? state.createphysiotherapyDutyCycleTest.filter(item => item.id !== action.payload.data.id)
          : [],  // Ensure it's an array before calling filter
        physiotherapyDeleteDutyCycle: action.payload.success, // Assuming you have this in your state
      };


    /*************************************************8 */
    case GETPHYSIOTHERAPYFREQUENCY:
      return {
        ...state,
        physiotherapyFrequencyList: Array.isArray(action.payload) ? action.payload : [], // Ensure the payload is an array
      };

    case CREATEPHYSIOTHERAPYFREQUENCY:
      return {
        ...state,
        createphysiotherapyFrequencyTest: action.payload.success,
      }

    case UPDATEPHYSIOTHERAPYFREQUENCYBYID:
      const updatedListFrequency = state.createphysiotherapyFrequencyTest.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        createphysiotherapyFrequencyTest: updatedListFrequency, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPYFREQUENCY:
      return {
        ...state,
        createphysiotherapyFrequencyTest: Array.isArray(state.createphysiotherapyFrequencyTest)
          ? state.createphysiotherapyFrequencyTest.filter(item => item.id !== action.payload.data.id)
          : [],  // Ensure it's an array before calling filter
        physiotherapyDeleteFrequency: action.payload.success, // Assuming you have this in your state
      };
    /*************************************************8 */
    case GETPHYSIOTHERAPYTDIAGNOSIS:
      return {
        ...state,
        physiotherapyDiagnosisList: Array.isArray(action.payload) ? action.payload : [], // Ensure the payload is an array
      };

    case CREATEPHYSIOTHERAPYDIAGNOSIS:
      return {
        ...state,
        createphysiotherapyDiagnosis: action.payload.success,
      }
    case UPDATEPHYSIOTHERAPYDIAGNOSISBYID:
      const updatedListDiagnosis = state.createphysiotherapyDiagnosis.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        createphysiotherapyDiagnosis: updatedListDiagnosis, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPYDIAGNOSIS:
      return {
        ...state,
        createphysiotherapyDiagnosis: Array.isArray(state.createphysiotherapyDiagnosis)
          ? state.createphysiotherapyDiagnosis.filter(item => item.id !== action.payload.data.id)
          : [],  // Ensure it's an array before calling filter
        physiotherapyDeleteDiagnosis: action.payload.success, // Assuming you have this in your state
      };

/*************************************************8 */
case GETPHYSIOTHERAPYTPROGNOSIS:
  return {
    ...state,
    physiotherapyPrognosisList: Array.isArray(action.payload) ? action.payload : [], // Ensure the payload is an array
  };

case CREATEPHYSIOTHERAPYPROGNOSIS:
  return {
    ...state,
    createphysiotherapyPrognosis: action.payload.success,
  }

case UPDATEPHYSIOTHERAPYPROGNOSISBYID:
  const updatedListPrognosis = state.createphysiotherapyPrognosis.map(item =>
    item.id === action.payload.data.id ? action.payload.data : item
  );
  return {
    ...state,
    createphysiotherapyPrognosis: updatedListPrognosis, // Update the list with the modified item
    editStatus: action.payload.success, // Set edit status
  };

case DELETEPHYSIOTHERAPYPROGNOSIS:
  return {
    ...state,
    createphysiotherapyPrognosis: Array.isArray(state.createphysiotherapyPrognosis)
      ? state.createphysiotherapyPrognosis.filter(item => item.id !== action.payload.data.id)
      : [],  // Ensure it's an array before calling filter
    physiotherapyDeletePrognosis: action.payload.success, // Assuming you have this in your state
  };


    /*********************************************************** */
    case GETPHYSIOTHERAPYTESTINVESTIGATION:
      return {
        ...state,
        physiotherapyTestInvestigationList: Array.isArray(action.payload) ? action.payload : [], // Ensure the payload is an array
      };

    case CREATEPHYSIOTHERAPYTESTINVESTIGATION:
      return {
        ...state,
        createphysiotherapyInvestigationTest: action.payload.success,
      }

    case UPDATEPHYSIOTHERAPYTESTTINVESTIGATIONBYID:
      const updatedListTestInvestigation = state.physiotherapyTestInvestigationList.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        physiotherapyTestInvestigationList: updatedListTestInvestigation, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPYTYPETINVESTIGATION:
      return {
        ...state,
        physiotherapyTestInvestigationList: state.physiotherapyTestInvestigationList.filter(item => item.id !== action.payload.data.id),
        physiotherapyDeleteInvestigationStatus: action.payload.success, // Assuming you have this in your state
      };




    case GETPHYSIOTHERAPYTEST:
      return {
        ...state,
        physiotherapyTestList: Array.isArray(action.payload) ? action.payload : [], // Ensure the payload is an array
      };


    case CREATEPHYSIOTHERAPYTEST:
      return {
        ...state,
        createphysiotherapyTest: action.payload.success,
      }

    case UPDATEPHYSIOTHERAPYTESTBYID:
      const updatedListTest = state.physiotherapyTestList.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        physiotherapyTestList: updatedListTest, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPYTYPE:
      return {
        ...state,
        physiotherapyTestList: state.physiotherapyTestList.filter(item => item.id !== action.payload.data.id),
        physiotherapyDeleteStatus: action.payload.success, // Assuming you have this in your state
      };


    case GETPHYSIOTHERAPYTESTTYPE:
      if (Array.isArray(action.payload) && action.payload.length > 0) {
        return {
          ...state,
          physiotherapytesttypeList: action.payload // Update with the new list
        };
      } else {
        console.warn("Received invalid payload for GETPHYSIOTHERAPYTESTTYPE:", action.payload);
        return {
          ...state,
          physiotherapytesttypeList: []
        };
      }

    case CREATEPHYSIOTHERAPYTESTTYPE:
      return {
        ...state,
        createphysiotherapyTestType: action.payload.success,
      }

    case UPDATEPHYSIOTHERAPYTESTTYPEBYID:
      const updatedListTestType = state.physiotherapytesttypeList.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        physiotherapytesttypeList: updatedListTestType, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPYTESTTYPE:
      return {
        ...state,
        physiotherapyTestList: Array.isArray(state.physiotherapyTestList)
          ? state.physiotherapyTestList.filter(item => item.id !== action.payload.id)
          : state.physiotherapyTestList, // Fallback if not an array
      };


    case GETPHYSIOTHERAPYDIURNAL:
      return {
        ...state,
        physiotherapyDiurnalList: action.payload,  // Update pain nature list
      };

    case CREATEPHYSIOTHERAPYDIURNAL:
      return {
        ...state,
        physiotherapyDiurnal: action.payload.success,
      }

    case UPDATEPHYSIOTHERAPYDIURNALBYID:
      const updatedListDiurnal = state.physiotherapyDiurnalList.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        physiotherapyDiurnalList: updatedListDiurnal, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPYDIURNAL:
      return {
        ...state,
        physiotherapyDiurnalList: state.physiotherapyDiurnalList.filter(item => item.id !== action.payload.id), // Now this should work
        physiotherapyDeleteDiurnal: action.payload.success,
      };

    /*************************************************************************************/
    case GETPHYSIOTHERAPYPAINONSET:
      return {
        ...state,
        physiotherapyOnSetList: action.payload,  // Update pain nature list
      };

    case CREATEPAINONSET:
      return {
        ...state,
        physiotherapyPainOnSet: action.payload.success,
      }
    case UPDATEPHYSIOTHERAPPAINONSETBYID:
      const updatedListPainOnSet = state.physiotherapyOnSetList.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        physiotherapyOnSetList: updatedListPainOnSet, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };
    case DELETEPAINONSET:
      return {
        ...state,
        physiotherapyOnSetList: state.physiotherapyOnSetList.filter(item => item.id !== action.payload.id), // Now this should work
        physiotherapyDeletePainOnSet: action.payload.success,
      };

    /*************************************************************************************/
    case GETPAINNATURE:
      return {
        ...state,
        painNatureList: action.payload.data // Update pain nature list
      };

    case CREATEPAINNATURE:
      return {
        ...state,
        painNatureSaveStatus: action.payload.success, // Update save status
      };

    case UPDATEPHYSIOTHERAPYPAINNATUREBYID:
      const updatedPainNatureList = state.painNatureList.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );

      return {
        ...state,
        painNatureList: updatedPainNatureList,
        editStatus: action.payload.success,  // Update the list with the modified item
      };

    case DELETEPAINNATURE:
      return {
        ...state,
        painNatureList: state.painNatureList.filter(item => item.id !== action.payload.data.id), // Remove deleted item
      };

    /*************************************************************************************/
    case GETPHYSIOTHERAPYSEVERITY:
      console.log("Payload in Reducer:", action.payload); // Log payload for debugging
      return {
        ...state,
        physiotherapySeverityList: action.payload.data

      }
    case CREATEPHYSIOTHERAPYSEVERITY:
      return {
        ...state,
        physiotherapySaveSeverity: action.payload.success,
      }
    case DELETEPHYSIOTHERAPYSEVERITY:
      return {
        ...state,
        physiotherapySeverityList: state.physiotherapySeverityList.filter(item => item.id !== action.payload.data.id),
        physiotherapyDeleteSeverity: action.payload.success
      };

    case UPDATEPHYSIOTHERAPYSEVERITYBYID:
      const updatedSeveityList = state.physiotherapySeverityList.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );
      return {
        ...state,
        physiotherapyList: updatedSeveityList, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    /*************************************************************************************/

    case GETPHYSIOTHERAPY:
      return {
        ...state,
        physiotherapyList: action.payload.data,
      }
    case CREATEPHYSIOTHERAPY:
      return {
        ...state,
        physiotherapySaveStatus: action.payload.success,
      }
    case UPDATEPHYSIOTHERAPYBYID:
      const updatedList = state.physiotherapyList.map(item =>
        item.id === action.payload.data.id ? action.payload.data : item
      );

      return {
        ...state,
        physiotherapyList: updatedList, // Update the list with the modified item
        editStatus: action.payload.success, // Set edit status
      };

    case DELETEPHYSIOTHERAPY:
      return {
        ...state,
        physiotherapyList: state.physiotherapyList.filter(item => item.id !== action.payload.data.id),
        physiotherapyDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
